import { DinRoundProFont } from '@/lib/utils';
import { toNumber } from 'lodash-es';
import Image from 'next/image';
import { twMerge } from 'tailwind-merge';
import Violet0 from '@/assets/numberCount/violet/0.png';
import Violet1 from '@/assets/numberCount/violet/1.png';
import Violet2 from '@/assets/numberCount/violet/2.png';
import Violet3 from '@/assets/numberCount/violet/3.png';
import Violet4 from '@/assets/numberCount/violet/4.png';
import Violet5 from '@/assets/numberCount/violet/5.png';
import Violet6 from '@/assets/numberCount/violet/6.png';
import Violet7 from '@/assets/numberCount/violet/7.png';
import Violet8 from '@/assets/numberCount/violet/8.png';
import Violet9 from '@/assets/numberCount/violet/9.png';
import MediumOrchid0 from '@/assets/numberCount/mediumOrchid/0.png';
import MediumOrchid1 from '@/assets/numberCount/mediumOrchid/1.png';
import MediumOrchid2 from '@/assets/numberCount/mediumOrchid/2.png';
import MediumOrchid3 from '@/assets/numberCount/mediumOrchid/3.png';
import MediumOrchid4 from '@/assets/numberCount/mediumOrchid/4.png';
import MediumOrchid5 from '@/assets/numberCount/mediumOrchid/5.png';
import MediumOrchid6 from '@/assets/numberCount/mediumOrchid/6.png';
import MediumOrchid7 from '@/assets/numberCount/mediumOrchid/7.png';
import MediumOrchid8 from '@/assets/numberCount/mediumOrchid/8.png';
import MediumOrchid9 from '@/assets/numberCount/mediumOrchid/9.png';
import SmashedPumpkin0 from '@/assets/numberCount/smashedPumpkin/0.png';
import SmashedPumpkin1 from '@/assets/numberCount/smashedPumpkin/1.png';
import SmashedPumpkin2 from '@/assets/numberCount/smashedPumpkin/2.png';
import SmashedPumpkin3 from '@/assets/numberCount/smashedPumpkin/3.png';
import SmashedPumpkin4 from '@/assets/numberCount/smashedPumpkin/4.png';
import SmashedPumpkin5 from '@/assets/numberCount/smashedPumpkin/5.png';
import SmashedPumpkin6 from '@/assets/numberCount/smashedPumpkin/6.png';
import SmashedPumpkin7 from '@/assets/numberCount/smashedPumpkin/7.png';
import SmashedPumpkin8 from '@/assets/numberCount/smashedPumpkin/8.png';
import SmashedPumpkin9 from '@/assets/numberCount/smashedPumpkin/9.png';
import GreenPantone0 from '@/assets/numberCount/greenPantone/0.png';
import GreenPantone1 from '@/assets/numberCount/greenPantone/1.png';
import GreenPantone2 from '@/assets/numberCount/greenPantone/2.png';
import GreenPantone3 from '@/assets/numberCount/greenPantone/3.png';
import GreenPantone4 from '@/assets/numberCount/greenPantone/4.png';
import GreenPantone5 from '@/assets/numberCount/greenPantone/5.png';
import GreenPantone6 from '@/assets/numberCount/greenPantone/6.png';
import GreenPantone7 from '@/assets/numberCount/greenPantone/7.png';
import GreenPantone8 from '@/assets/numberCount/greenPantone/8.png';
import GreenPantone9 from '@/assets/numberCount/greenPantone/9.png';
import Orange0 from '@/assets/numberCount/orange/0.png';
import Orange1 from '@/assets/numberCount/orange/1.png';
import Orange2 from '@/assets/numberCount/orange/2.png';
import Orange3 from '@/assets/numberCount/orange/3.png';
import Orange4 from '@/assets/numberCount/orange/4.png';
import Orange5 from '@/assets/numberCount/orange/5.png';
import Orange6 from '@/assets/numberCount/orange/6.png';
import Orange7 from '@/assets/numberCount/orange/7.png';
import Orange8 from '@/assets/numberCount/orange/8.png';
import Orange9 from '@/assets/numberCount/orange/9.png';
import LavenderPurple0 from '@/assets/numberCount/lavenderPurple/0.png';
import LavenderPurple1 from '@/assets/numberCount/lavenderPurple/1.png';
import LavenderPurple2 from '@/assets/numberCount/lavenderPurple/2.png';
import LavenderPurple3 from '@/assets/numberCount/lavenderPurple/3.png';
import LavenderPurple4 from '@/assets/numberCount/lavenderPurple/4.png';
import LavenderPurple5 from '@/assets/numberCount/lavenderPurple/5.png';
import LavenderPurple6 from '@/assets/numberCount/lavenderPurple/6.png';
import LavenderPurple7 from '@/assets/numberCount/lavenderPurple/7.png';
import LavenderPurple8 from '@/assets/numberCount/lavenderPurple/8.png';
import LavenderPurple9 from '@/assets/numberCount/lavenderPurple/9.png';
import MediumOrchidGradient0 from '@/assets/numberCount/mediumOrchidGradient/0.png';
import MediumOrchidGradient1 from '@/assets/numberCount/mediumOrchidGradient/1.png';
import MediumOrchidGradient2 from '@/assets/numberCount/mediumOrchidGradient/2.png';
import MediumOrchidGradient3 from '@/assets/numberCount/mediumOrchidGradient/3.png';
import MediumOrchidGradient4 from '@/assets/numberCount/mediumOrchidGradient/4.png';
import MediumOrchidGradient5 from '@/assets/numberCount/mediumOrchidGradient/5.png';
import MediumOrchidGradient6 from '@/assets/numberCount/mediumOrchidGradient/6.png';
import MediumOrchidGradient7 from '@/assets/numberCount/mediumOrchidGradient/7.png';
import MediumOrchidGradient8 from '@/assets/numberCount/mediumOrchidGradient/8.png';
import MediumOrchidGradient9 from '@/assets/numberCount/mediumOrchidGradient/9.png';
import OrangeRedGradient0 from '@/assets/numberCount/orangeRedGradient/0.png';
import OrangeRedGradient1 from '@/assets/numberCount/orangeRedGradient/1.png';
import OrangeRedGradient2 from '@/assets/numberCount/orangeRedGradient/2.png';
import OrangeRedGradient3 from '@/assets/numberCount/orangeRedGradient/3.png';
import OrangeRedGradient4 from '@/assets/numberCount/orangeRedGradient/4.png';
import OrangeRedGradient5 from '@/assets/numberCount/orangeRedGradient/5.png';
import OrangeRedGradient6 from '@/assets/numberCount/orangeRedGradient/6.png';
import OrangeRedGradient7 from '@/assets/numberCount/orangeRedGradient/7.png';
import OrangeRedGradient8 from '@/assets/numberCount/orangeRedGradient/8.png';
import OrangeRedGradient9 from '@/assets/numberCount/orangeRedGradient/9.png';

export enum NumberCountEnum {
  MediumOrchid,
  MediumOrchidGradient,
  OrangeRedGradient,
  Violet,
  SmashedPumpkin,
  GreenPantone,
  Orange,
  LavenderPurple,
}
const numberImages = {
  [NumberCountEnum.MediumOrchid]: [
    MediumOrchid0,
    MediumOrchid1,
    MediumOrchid2,
    MediumOrchid3,
    MediumOrchid4,
    MediumOrchid5,
    MediumOrchid6,
    MediumOrchid7,
    MediumOrchid8,
    MediumOrchid9,
  ],
  [NumberCountEnum.Violet]: [
    Violet0,
    Violet1,
    Violet2,
    Violet3,
    Violet4,
    Violet5,
    Violet6,
    Violet7,
    Violet8,
    Violet9,
  ],
  [NumberCountEnum.SmashedPumpkin]: [
    SmashedPumpkin0,
    SmashedPumpkin1,
    SmashedPumpkin2,
    SmashedPumpkin3,
    SmashedPumpkin4,
    SmashedPumpkin5,
    SmashedPumpkin6,
    SmashedPumpkin7,
    SmashedPumpkin8,
    SmashedPumpkin9,
  ],
  [NumberCountEnum.GreenPantone]: [
    GreenPantone0,
    GreenPantone1,
    GreenPantone2,
    GreenPantone3,
    GreenPantone4,
    GreenPantone5,
    GreenPantone6,
    GreenPantone7,
    GreenPantone8,
    GreenPantone9,
  ],
  [NumberCountEnum.Orange]: [
    Orange0,
    Orange1,
    Orange2,
    Orange3,
    Orange4,
    Orange5,
    Orange6,
    Orange7,
    Orange8,
    Orange9,
  ],
  [NumberCountEnum.LavenderPurple]: [
    LavenderPurple0,
    LavenderPurple1,
    LavenderPurple2,
    LavenderPurple3,
    LavenderPurple4,
    LavenderPurple5,
    LavenderPurple6,
    LavenderPurple7,
    LavenderPurple8,
    LavenderPurple9,
  ],
  [NumberCountEnum.MediumOrchidGradient]: [
    MediumOrchidGradient0,
    MediumOrchidGradient1,
    MediumOrchidGradient2,
    MediumOrchidGradient3,
    MediumOrchidGradient4,
    MediumOrchidGradient5,
    MediumOrchidGradient6,
    MediumOrchidGradient7,
    MediumOrchidGradient8,
    MediumOrchidGradient9,
  ],
  [NumberCountEnum.OrangeRedGradient]: [
    OrangeRedGradient0,
    OrangeRedGradient1,
    OrangeRedGradient2,
    OrangeRedGradient3,
    OrangeRedGradient4,
    OrangeRedGradient5,
    OrangeRedGradient6,
    OrangeRedGradient7,
    OrangeRedGradient8,
    OrangeRedGradient9,
  ],
};
function NumberCount({
  number,
  type = NumberCountEnum.Violet,
  customClassName,
}: {
  number: number;
  type?: NumberCountEnum;
  customClassName?: string;
}) {
  const digits = [...String(number)];

  return (
    <div>
      <span
        className={twMerge(
          'text-white [-webkit-text-stroke-color:#7D08B6] [-webkit-text-stroke-width:3px] text-[30px] font-[900]',
          DinRoundProFont.className,
        )}
      >
        <div className="flex flex-row">
          {digits.map((digit, index) => {
            const keyMap = `${type}-${digit}-${index}`;
            return (
              <Image
                key={keyMap}
                alt="flyer"
                src={numberImages[type][toNumber(digit)] || LavenderPurple9}
                className={twMerge(
                  'w-[28px] h-auto',
                  index > 0 ? 'ml-[-11px]' : '',
                  customClassName,
                )}
              />
            );
          })}
        </div>
      </span>
    </div>
  );
}
export default NumberCount;
